import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import DoDisturbIcon from "@mui/icons-material/DoDisturb";
import TextCard from "../cards/TextCard";

const style = {
  position: "absolute" as "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const Item = styled(Paper)(() => ({
  backgroundColor: "#fff",
  textAlign: "center",
}));
export default function ModalCmp({ openModel, validationMessages,firstPartOfTitle,boldTitle,secondPartOfTitle }: any) {
  const [open, setOpen] = React.useState(openModel);
  const [messages, setMessages] = React.useState(validationMessages);
  const handleClose = () => setOpen(false);
  React.useEffect(() => {
    
    setOpen(openModel);
  }, [openModel]);
  React.useEffect(() => {
    setMessages(validationMessages);
  }, [validationMessages]);

  return (
    <div>
      <Modal
        keepMounted
        open={open}
        onClose={handleClose}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box
          sx={style}
          style={{ borderRadius: "6px" }}
          className="ModalCmp textCenter"
        >
          <DoDisturbIcon className="classIcons colorCancel  textCenter marginLeft-10" />
          <Typography className="textCenter mTop30 mbottom20">
            {firstPartOfTitle}{" "}
            <span className="colorCancel">{boldTitle}</span> {secondPartOfTitle}
          </Typography>
          {/* <Typography className="textCenter mTop30 mbottom20">
            درخواست تسهیلات به دلایل زیر{" "}
            <span className="colorCancel">پذیرفته</span> نشد:
          </Typography> */}
          <Grid>
            <TextCard inputMessages={messages} bgColor="#fff" />
          </Grid>
          <Grid container spacing={2} columns={16} className="mTop20">
            <Button
              fullWidth
              className="btnForm DangerDefault  mTop40"
              onClick={handleClose}
            >
              بازگشت
            </Button>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
}
